import React, { Component, Fragment } from "react";
import ReactHtmlParser from "react-html-parser";
import Loader from "./Loader";
import { formatTimestamp } from "../../../Utils/utils";

const ecosystem_svg = require("../../../assets/media/icons/ecosystem-logo.svg");

class MessageItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: props.loaded,
      img_src: props.icon,
    };
  }

  componentDidMount() {
    this.setState({ loaded: this.props.loaded });
  }

  render() {
    const { type, message, username, time } = this.props.message;
    const { loaded, img_src } = this.state;

    const messageComponent = `<p>${message}</p><span class="${
      time ? "message__timestamp" : "message__timestamp--hidden"
    }">${formatTimestamp(time)}</span>`;

    return (
      <Fragment>
        <div
          style={
            type === "brand"
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  marginBottom: 16,
                  position: "relative",
                  marginRight: 50,
                }
              : {
                  display: "flex",
                  alignSelf: "flex-end",
                  maxWidth: "100%",
                  marginBottom: 16,
                  position: "relative",
                  marginLeft: 50,
                }
          }
        >
          {type === "brand" && (
            <div
              className="avatar"
              style={{ backgroundImage: `url(${img_src})` }}
              alt="concierge"
            />
          )}

          <div
            className={`message-item-wrapper ${
              loaded ? "loaded" : ""
            } ${type} `}
          >
            <Loader />
            <p
              className={`message__username`}
              style={{
                left: type === "brand" ? 65 : "unset",
                right: type === "brand" ? "unset" : "",
              }}
            >
              {username}
            </p>
            <div className={`message`}>{ReactHtmlParser(messageComponent)}</div>
          </div>
          {(type === "admin" || type === "bot") && (
            <div
              className="avatar"
              style={{
                backgroundImage: `url(${ecosystem_svg})`,
                backgroundSize: 30,
              }}
              alt="concierge"
            />
          )}
        </div>
      </Fragment>
    );
  }
}

export default MessageItem;



// WEBPACK FOOTER //
// ./src/screens/AdminSupport/LiveChat/MessageItem.js